import { render, staticRenderFns } from "./SocialFeedSegment.vue?vue&type=template&id=3908a670&"
import script from "./SocialFeedSegment.vue?vue&type=script&lang=js&"
export * from "./SocialFeedSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports